import React from 'react';
import { ReactGoogleReviews } from 'react-google-reviews';
import 'react-google-reviews/dist/index.css';
import { useEffect } from 'react';
import "./Testimonials.css";

function Testimonials() {
  const apiKey = "AIzaSyByCU5K2gupWEKZ9g2klGeczXYUuJ-RE7Y";
  const placeId = "ChIJW8_QUr9bGjkRxC77z4P67I4";

  return (
    <section className="testimonials bg-color">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="sub-title">Businesses Grow Better with CDM</h2>
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-md-5"></div>
          <div className="col-md-7">
            <h2 className="main-title split-text">
              Accelerating growth, and unlocking new potential. Let’s build your brand—together.
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ReactGoogleReviews apiKey={apiKey} placeId={placeId} layout="carousel" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
